import { Theme, Box, Flex } from '@radix-ui/themes';
import { Outlet, useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import { useEffect } from 'react';
import { loginUserWithToken } from '../services/authService';
import { updateUser } from '../redux/slices/userSlice';
import { updateAccount } from '../redux/slices/accountSlice';
import SiteHeader from '../components/SiteHeader';

export default function PublicLayout() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {

    const handleLoginWithToken = async () => {
      const authToken = localStorage.getItem('authToken')
      if (authToken && authToken !== "undefined") {
        const response = await loginUserWithToken(authToken)
        dispatch(updateUser(response.user))
        dispatch(updateAccount(response.account))
      }
    }
    handleLoginWithToken()

  }, [])

  return (
    <Theme>
      <Flex direction="column" className="public-layout" minWidth="100vw" minHeight="100vh">
        <SiteHeader />
        <main>
          <Outlet />
        </main>
        <Box mt="auto">
          <Footer />
        </Box>
      </Flex>
    </Theme>
  );
} 